"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crypt = void 0;
/* eslint-disable no-unused-vars */
const prime_cryptography_1 = require("@telus/prime-cryptography");
const decrypt = ({ name, encryptedValue, salt, logger }) => {
    try {
        const decryptedData = prime_cryptography_1.cryptography.decrypt(name, encryptedValue, salt);
        // using a wrong salt will return a value that is not a number (ex: )@:P)
        if (decryptedData && !Number.isNaN(Number(decryptedData))) {
            return decryptedData;
        }
    }
    catch (err) {
        logger.error('Error decrypting data');
    }
};
const encrypt = ({ name, data, salt, logger }) => {
    try {
        return prime_cryptography_1.cryptography.encrypt(name, data, salt);
    }
    catch (error) {
        logger.error('Error encrypting data');
    }
};
exports.crypt = {
    decrypt(input) {
        return decrypt(input);
    },
    encrypt(input) {
        return encrypt(input);
    },
    decryptBan({ encryptedBan, salt, logger }) {
        return decrypt({ name: 'ban', encryptedValue: encryptedBan, salt, logger });
    },
    encryptBan({ ban, salt, logger }) {
        return encrypt({ name: 'ban', data: ban, salt, logger });
    },
    decryptSub({ encryptedSub, salt, logger }) {
        return decrypt({ name: 'sub', encryptedValue: encryptedSub, salt, logger });
    },
    encryptSub({ sub, salt, logger }) {
        return encrypt({ name: 'sub', data: sub, salt, logger });
    }
};
//# sourceMappingURL=index.js.map